import { createFileRoute } from '@tanstack/react-router';

import SupplierPortalQuoteRequestPage from '@/areas/quote-requests/SupplierPortal/SupplierPortalQuoteRequestPage/SupplierPortalQuoteRequestPage';
import { canAccessSupplierPortal } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/supplier-portal/quote-requests/$quoteRequestId/')({
    staticData: { access: { permissions: canAccessSupplierPortal }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <SupplierPortalQuoteRequestPage {...pathParams} />;
}
